export type CancelPromiseHandler = () => void;

export interface IMakeCancellablePromise<T> {
  promise: Promise<T>;
  cancel: CancelPromiseHandler;
}

export function makeCancellablePromise<T>(promise: Promise<T>): IMakeCancellablePromise<T> {
  let isCancelled = false;

  const wrappedPromise: typeof promise = new Promise((resolve, reject) => {
    promise
      .then((value) => !isCancelled && resolve(value))
      .catch((error) => !isCancelled && reject(error));
  });

  return {
    promise: wrappedPromise,
    cancel(): void {
      isCancelled = true;
    },
  };
}
